import axios from "../axios";

export const checkBackendHealth = async () => {
  try {
    // Ideally, your backend has a `/health` or `/status` endpoint.
    const res = await axios.get("/healthz");
    return res.status === 200;
  } catch (err) {
    console.error("Backend health check failed:", err.message);
    return false;
  }
};
